//1 = light blue, 2 = blue, 3 = yellow, 4 = red

export const chainmail = [
    0, 0, 5, 0, 0, 0, 0, 0, 0, 5, 0, 0, 
    0, 5, 1, 2, 1, 0, 0, 2, 1, 2, 5, 0, 
    5, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 5, 
    0, 2, 1, 2, 1, 3, 3, 2, 1, 2, 1, 0, 
    0, 4, 4, 1, 2, 3, 3, 1, 2, 4, 4, 0, 
    0, 5, 5, 2, 1, 2, 1, 2, 1, 5, 5, 0, 
    0, 0, 0, 1, 2, 1, 2, 1, 2, 0, 0, 0, 
    0, 0, 0, 2, 1, 2, 1, 2, 1, 0, 0, 0, 
    0, 0, 0, 1, 2, 1, 2, 1, 2, 0, 0, 0, 
    0, 0, 0, 2, 1, 2, 1, 2, 1, 0, 0, 0, 
    0, 0, 0, 1, 2, 1, 2, 1, 2, 0, 0, 0, 
    0, 0, 0, 4, 4, 4, 4, 4, 4, 0, 0, 0,
]